export default {"src":"/_next/static/media/initial_interview.37370ace.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};